import { Check, Link2 } from 'lucide-react';
import { IconButton, Status, StatusPill, formatEuro } from '@elbklar/ui';
import type { Anfrage } from '@/lib/api';
import { projektUrl } from '@/lib/pm';

interface AnfrageCardProps {
  anfrage: Anfrage;
  customerName?: string;
  onClose?: (anfrage: Anfrage) => void;
}

export function AnfrageCard({ anfrage, customerName, onClose }: AnfrageCardProps) {
  const isClosed = anfrage.status === 'GEWONNEN' || anfrage.status === 'VERLOREN';
  // Titel ist der Kundenwunsch — die Sales-Notiz ist intern und stand bis
  // 12.10.2026 faelschlich vorn (Trockenlauf, Befund 15).
  const title = anfrage.kundenwunsch || anfrage.sales_nachricht || customerName || 'Anfrage';

  return (
    <div
      draggable={!isClosed}
      className={`rounded-lg border border-border bg-card p-3 ${isClosed ? 'cursor-default opacity-75' : 'cursor-move hover:border-input'}`}
      data-anfrage-id={anfrage.id}
    >
      <div className="flex items-start justify-between gap-2">
        <h4 className="line-clamp-2 t-body-strong">{title}</h4>
        <div className="flex shrink-0 items-center gap-1">
          {/* Die Marke war bis zum 28.10.2026 ein `<span title>` — sichtbar,
              aber kein Weg irgendwohin. Wer nachsehen wollte, wechselte die
              App und riet den Projektnamen (Ü-12). */}
          {anfrage.project_ref_id && (
            <a
              href={projektUrl(anfrage.project_ref_id)}
              target="_blank"
              rel="noopener noreferrer"
              title="Projekt in PM öffnen"
              onClick={(e) => e.stopPropagation()}
            >
              <StatusPill tone="success">
                <Link2 size={12} strokeWidth={1.75} aria-hidden />
                PM
              </StatusPill>
            </a>
          )}
          {!isClosed && onClose && (
            <IconButton
              icon={Check}
              label="Anfrage abschließen"
              variant="ghost"
              size="sm"
              onClick={(e) => {
                e.stopPropagation();
                onClose(anfrage);
              }}
            />
          )}
        </div>
      </div>

      {customerName && title !== customerName && <p className="mt-1 t-small text-muted-foreground">{customerName}</p>}

      <div className="mt-2 flex items-center justify-between gap-2">
        <span className="t-body-strong tabular">{formatEuro(anfrage.value)}</span>
        {anfrage.dringlichkeit && (
          <Status status={`dringlichkeit_${anfrage.dringlichkeit}`} variant="plain" />
        )}
      </div>

      {anfrage.status === 'VERLOREN' && anfrage.lost_reason && (
        <p className="mt-2 line-clamp-2 t-small text-danger">{anfrage.lost_reason}</p>
      )}
    </div>
  );
}
